import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

/**
 * The signed-in staff member's business unit assignment, read from the auth state.
 *
 * `assignedBusinessUnitIds` is what is on their profile (it can include a unit that has since
 * been deleted). It is empty for super admins, who are never limited.
 * `isLimitedToBusinessUnits` is true when they are assigned to at least one unit.
 */
export const useStaffBusinessUnits = () => {
  const currentUser = useSelector((state: RootState) => state.auth.userInfo?.user);

  const isSuperAdmin = currentUser?.role_id === 1 || Boolean(currentUser?.is_super_admin);
  const rawIds = currentUser?.business_unit_ids ?? currentUser?.bu_ids;

  const assignedBusinessUnitIds = useMemo<number[]>(
    () => (isSuperAdmin || !Array.isArray(rawIds) ? [] : rawIds.map(Number)),
    [isSuperAdmin, rawIds]
  );

  return {
    isSuperAdmin,
    assignedBusinessUnitIds,
    isLimitedToBusinessUnits: assignedBusinessUnitIds.length > 0,
  };
};
